export const IMPERSONATOR_TOKEN_KEY = 'impersonatorToken';
export const IMPERSONATOR_USER_KEY = 'impersonatorUser';
export const IMPERSONATED_UID_KEY = 'impersonatedUid';

export function clearImpersonationStorage(): void {
    try {
        localStorage.removeItem(IMPERSONATOR_TOKEN_KEY);
        localStorage.removeItem(IMPERSONATOR_USER_KEY);
        localStorage.removeItem(IMPERSONATED_UID_KEY);
    } catch {
        // ignore storage errors
    }
}

export function readImpersonatorToken(): string | null {
    try {
        return localStorage.getItem(IMPERSONATOR_TOKEN_KEY);
    } catch {
        return null;
    }
}

export function readImpersonatorUserRaw(): string | null {
    try {
        return localStorage.getItem(IMPERSONATOR_USER_KEY);
    } catch {
        return null;
    }
}

export function readImpersonatedUid(): string | null {
    try {
        const value = localStorage.getItem(IMPERSONATED_UID_KEY);
        return value && value.trim() ? value.trim() : null;
    } catch {
        return null;
    }
}

/** Non-destructive: true when admin restore keys are present (no uid validation side effects). */
export function hasStoredImpersonationSession(): boolean {
    return Boolean(readImpersonatorToken() && readImpersonatedUid());
}

